import { createStore } from 'vuex'
import createPersistedState from "vuex-persistedstate";
import { EncryptStorage } from 'encrypt-storage';
// import axios from 'axios';
// import qs from 'qs';

export const encryptStorage = new EncryptStorage(toString('exposed2024'), {
  storageType: 'localStorage',
  stateManagementUse: true
});

export default createStore({
  state: {
    user: null,
    username: null, 
    avatar: null,
    isVerified: false
  },
  getters: {
  },
  mutations: {
    UPDATE_USER(state, payload){
      state.user = payload
    },
    UPDATE_USERNAME(state, payload){
      state.username = payload
    },
    UPDATE_AVATAR(state, user) {
      state.avatar = user.avatar;
    },
    UPDATE_ISVERIFIED(state, payload) {
      state.isVerified = payload;
    },
    SET_SHOW_APOLOGY(state, payload) {
      state.showApology = payload; 
    },
    SET_AGE_CONFIRMED(state, payload) {
      state.ageConfirmed = payload;
      encryptStorage.setItem("ageConfirmed", payload);
      const expiry = Date.now() + 3600 * 1000; 
      state.expiryTime = expiry;
      encryptStorage.setItem("expiryTime", expiry);
    },
    SET_RESPONSIBILITY_CONFIRMED(state, payload) {
      state.responsibilityConfirmed = payload;
      encryptStorage.setItem("responsibilityConfirmed", payload);
    },
    RESET_CONFIRMATIONS(state) {
      state.ageConfirmed = false;
      state.responsibilityConfirmed = false;
      state.expiryTime = null;
      encryptStorage.removeItem("ageConfirmed");
      encryptStorage.removeItem("responsibilityConfirmed");
      encryptStorage.removeItem("expiryTime");
    }
  },
  actions: {
    toggleApology({ commit }, value) {
      commit("SET_SHOW_APOLOGY", value); 
    },
    acceptAge({ commit }) {
      commit("SET_AGE_CONFIRMED", true);
    },
    acceptResponsibilities({ commit }) {
      commit("SET_RESPONSIBILITY_CONFIRMED", true);
    },
    checkExpiry({ commit, state }) {
      const now = Date.now();
      if (state.expiryTime && now >= state.expiryTime) {
        commit("RESET_CONFIRMATIONS"); 
      }
    }  
  },
  modules: {
  },
  plugins: [createPersistedState({ 
    storage: { 
      setItem: (key, state) => encryptStorage.setItem(key, state),
      getItem: (key) => encryptStorage.getItem(key),
      removeItem: (key) => encryptStorage.removeItem(key)
    }
  })],
})
